import React from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import FormFieldWithLabel from '../../../../common/FormFieldWithLabel';
import { drapcodeIcon } from '../../../../../common/custom/icon-library';
import { validationSchemaForDomains } from '../../../../../common/utils/validate';
import { getProtocolForCustomDomains } from '../../../../../common/utils/environments';
import ParentCardNoCol from '../../../../common/ParentCardNoCol';
import Swal from 'sweetalert2';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
const CustomDomains = ({ projectDetail, actions, projectId, version, isReadOnly }) => {
  const { protocol, isFreeProject } = getProtocolForCustomDomains(projectDetail);
  const handleDomainsUpdate = async (values, { setSubmitting }) => {
    setSubmitting(true);

    if (isFreeProject) {
      console.log('Project type is free or unspecified.');
      setSubmitting(false);
      return;
    }

    const result = await Swal.fire({
      title: 'Are you sure?',
      text: 'Do you want to update the custom domains?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, update it!',
      cancelButtonText: 'No, cancel!',
    });

    if (result.isConfirmed) {
      try {
        const { name, description, timezone, projectType, projectLogoKeyName, faviconKeyName } =
          projectDetail;
        const formData = new FormData();
        formData.append('domainName', values.domainName.trim());
        // formData.append('apiDomainName', values.apiDomainName.trim());
        formData.append('name', name);
        formData.append('description', description);
        formData.append('timezone', timezone);
        formData.append('projectType', projectType);
        if (projectLogoKeyName) {
          formData.append('projectLogoKeyName', projectLogoKeyName);
        }
        if (faviconKeyName) {
          formData.append('faviconKeyName', faviconKeyName);
        }

        await actions.customDomainsUpdate({ projectId, formData });
      } catch (error) {
        console.error('Error submitting form:', error);
      } finally {
        setSubmitting(false);
      }
    } else {
      setSubmitting(false);
    }
  };
  const { domainName, apiDomainName } = projectDetail;
  return (
    <ParentCardNoCol title="Custom Domains" icon="customJsCDN" bgColor="drapcode-violet">
      <Formik
        initialValues={{
          domainName: domainName || '',
          // apiDomainName: apiDomainName || '',
        }}
        validationSchema={validationSchemaForDomains}
        onSubmit={isReadOnly ? null : handleDomainsUpdate}
        enableReinitialize={true}
      >
        {({ isSubmitting }) => (
          <Form encType="multipart/form-data">
            <div className="form-group">
              <FormFieldWithLabel
                cta={false}
                label={`Custom Domain
                  ${isFreeProject ? ' (To enable it please upgrade your account.)' : ''}`}
                icon={protocol}
                infoIcon={false}
              >
                <Field
                  type="text"
                  name="domainName"
                  className="form-control form-control-sm"
                  placeholder="Custom Domain"
                  disabled={isFreeProject}
                  readOnly={isFreeProject}
                  style={{
                    padding: isFreeProject ? '0px' : '8px',
                  }}
                />
                <ErrorMessage name="domainName" component="p" className="text-danger" />
              </FormFieldWithLabel>
            </div>

            <div className="col-md-12 col-lg-12 mt-2 text-right d-flex justify-content-between">
              <Link
                to={`/app-setting/${version}/v/${projectId}/setting/app-config`}
                className="btn btn-outline btn-md"
              >
                <i className="wb webconnect-times"></i> Cancel
              </Link>
              <button
                type={isFreeProject ? 'button' : 'submit'}
                className={isFreeProject ? 'btn btn-default btn-md' : 'btn btn-theme-submit btn-md'}
                disabled={isFreeProject || isSubmitting || isReadOnly}
                title={isReadOnly && 'Read-Only Mode'}
              >
                <i className={`wb ${drapcodeIcon('save')}`}></i>&nbsp;Update&nbsp;
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </ParentCardNoCol>
  );
};

export default CustomDomains;
